import LocalStorageKeys from "../core/localstorageKeys";

const TOKEN_NAME = LocalStorageKeys.adminToken;

const getCookie = (name: string): string | null => {
  const value = document.cookie
    .split("; ")
    .find((row) => row.startsWith(encodeURIComponent(name) + "="))
    ?.split("=")[1];
  return value ? decodeURIComponent(value) : null;
};

export const getToken = (): string | null => {
  return getCookie(TOKEN_NAME);
};

export const setToken = (token: string, days: number = 365): void => {
  const secure = window.location.protocol === "https:";
  const maxAge = Math.max(0, Math.floor(days * 24 * 60 * 60));
  document.cookie =
    `${encodeURIComponent(TOKEN_NAME)}=${encodeURIComponent(token)};` +
    ` Path=/; SameSite=Lax; Max-Age=${maxAge}` +
    (secure ? "; Secure" : "");
};

export const removeToken = (): void => {
  const secure = window.location.protocol === "https:";
  document.cookie =
    `${encodeURIComponent(TOKEN_NAME)}=; Path=/; SameSite=Lax; Max-Age=0` +
    (secure ? "; Secure" : "");
};

export const isTokenExpired = (token: string): boolean => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const currentTime = Date.now() / 1000;
    return payload.exp < currentTime;
  } catch {
    return true;
  }
};

export const decodeToken = (token: string): any => {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch {
    return null;
  }
};
